/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Empty_No_KeywordsInputs */

const en_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const de_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const fr_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const es_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const it_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const nl_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const pl_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const fi_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const da_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

const sv_keyword_optimizer_empty_no_keywords = /** @type {(inputs: Keyword_Optimizer_Empty_No_KeywordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keywords found for this category.`)
};

/**
* | output |
* | --- |
* | "No keywords found for this category." |
*
* @param {Keyword_Optimizer_Empty_No_KeywordsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_empty_no_keywords = /** @type {((inputs?: Keyword_Optimizer_Empty_No_KeywordsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Empty_No_KeywordsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_empty_no_keywords(inputs)
	if (locale === "fr") return fr_keyword_optimizer_empty_no_keywords(inputs)
	if (locale === "es") return es_keyword_optimizer_empty_no_keywords(inputs)
	if (locale === "it") return it_keyword_optimizer_empty_no_keywords(inputs)
	if (locale === "nl") return nl_keyword_optimizer_empty_no_keywords(inputs)
	if (locale === "pl") return pl_keyword_optimizer_empty_no_keywords(inputs)
	if (locale === "fi") return fi_keyword_optimizer_empty_no_keywords(inputs)
	if (locale === "da") return da_keyword_optimizer_empty_no_keywords(inputs)
	if (locale === "sv") return sv_keyword_optimizer_empty_no_keywords(inputs)
	return en_keyword_optimizer_empty_no_keywords(inputs)
});